<template>
  <div class="halaman-admin">
    <!-- Modal Konfirmasi Delete -->
    <div class="modal fade" id="deleteModal" tabindex="-1" aria-labelledby="deleteModalLabel" aria-hidden="true" ref="deleteModal">
      <div class="modal-dialog modal-dialog-centered">
        <div class="modal-content">
          <div class="modal-header">
            <h5 class="modal-title" id="deleteModalLabel">Konfirmasi Hapus Jadwal</h5>
         
          </div>
          <div class="modal-body">
            Apakah kamu yakin ingin menghapus jadwal ini?
          </div>
          <div class="modal-footer">
            <button type="button" class="btn btn-secondary" data-bs-dismiss="modal">Batal</button>
            <button type="button" class="btn btn-danger" @click="deleteSchedule">Hapus</button>
          </div>
        </div>
      </div>
    </div>

    <!-- Modal Konfirmasi Bulk Delete Jadwal -->
    <div class="modal fade" id="bulkDeleteScheduleModal" tabindex="-1" aria-hidden="true" ref="bulkDeleteScheduleModal">
      <div class="modal-dialog modal-dialog-centered">
        <div class="modal-content">
          <div class="modal-header">
            <h5 class="modal-title text-danger">
              <i class="bi bi-exclamation-triangle-fill me-1"></i> Konfirmasi Hapus Sekaligus
            </h5>
            <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
          </div>
          <div class="modal-body">
            Apakah Anda yakin ingin menghapus <strong>{{ selectedScheduleIds.length }}</strong> jadwal pertandingan yang dipilih? Tindakan ini tidak dapat dibatalkan.
          </div>
          <div class="modal-footer">
            <button type="button" class="btn btn-secondary btn-sm" data-bs-dismiss="modal">Batal</button>
            <button type="button" class="btn btn-danger btn-sm" :disabled="bulkDeletingSchedule" @click="deleteBulkSchedule">
              <span v-if="bulkDeletingSchedule" class="spinner-border spinner-border-sm me-1"></span>
              <i v-else class="bi bi-trash-fill me-1"></i> Ya, Hapus Semua
            </button>
          </div>
        </div>
      </div>
    </div>

    <!-- Modal Urutkan Ulang Nomor Partai -->
    <div class="modal fade" id="reorderModal" tabindex="-1" aria-labelledby="reorderModalLabel" aria-hidden="true" ref="reorderModal">
      <div class="modal-dialog modal-dialog-centered">
        <div class="modal-content">
          <div class="modal-header">
            <h5 class="modal-title" id="reorderModalLabel">
              <i class="bi bi-arrow-repeat text-primary me-1"></i> Urutkan Ulang Nomor Partai
            </h5>
            <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
          </div>
          <div class="modal-body">
            <p class="small text-muted mb-3">
              Susun ulang nomor partai agar urut dan tidak bertubrukan.
            </p>
            <div class="mb-3">
              <label class="form-label fw-semibold">Pilih Turnamen <span class="text-danger">*</span></label>
              <select v-model="reorderForm.tournament_id" class="form-select" @change="loadModalArenas" required>
                <option value="" disabled>Pilih Turnamen</option>
                <option v-for="t in allTournaments" :key="t.id" :value="t.id">{{ t.name }}</option>
              </select>
            </div>
            <div class="mb-3">
              <label class="form-label fw-semibold">Pilih Gelanggang (Arena)</label>
              <select v-model="reorderForm.tournament_arena_id" class="form-select">
                <option value="">Semua Gelanggang (Masing-masing mulai dari Partai 1)</option>
                <option v-for="a in modalArenas" :key="a.id" :value="a.id">{{ a.name }}</option>
              </select>
              <small class="text-muted">Pilih gelanggang tertentu jika hanya ingin mengurutkan partai di gelanggang tersebut.</small>
            </div>
            <div class="mb-3">
              <label class="form-label fw-semibold">Nomor Partai Awal</label>
              <input type="number" min="1" v-model.number="reorderForm.start_order" class="form-control" placeholder="1" />
              <small class="text-muted">Nomor partai pertama yang akan diterapkan (default: 1).</small>
            </div>
          </div>
          <div class="modal-footer">
            <button type="button" class="btn btn-secondary" data-bs-dismiss="modal">Batal</button>
            <button type="button" class="btn btn-primary" :disabled="!reorderForm.tournament_id || reordering" @click="submitReorder">
              <span v-if="reordering" class="spinner-border spinner-border-sm me-1"></span>
              <i v-else class="bi bi-check2-circle me-1"></i> Urutkan Sekarang
            </button>
          </div>
        </div>
      </div>
    </div>

    <!-- Main Container -->
    <div class="card p-4">
      <div class="d-flex flex-wrap justify-content-between align-items-center mb-3 gap-2">
        <h4 class="mb-0">Jadwal Pertandingan</h4>
        <div class="d-flex flex-wrap gap-2 align-items-center">
          <button type="button" class="btn btn-outline-secondary btn-sm d-flex align-items-center gap-1" @click="openReorderModal">
            <i class="bi bi-arrow-repeat"></i> Urutkan Ulang Nomor Partai
          </button>
          <router-link to="/admin/tournament-schedule/tanding/create" class="btn btn-primary btn-sm d-flex align-items-center gap-1">
            <i class="bi bi-plus-lg"></i> Buat Jadwal Tanding
          </router-link>
          <router-link to="/admin/tournament-schedule/seni/create" class="btn btn-success btn-sm d-flex align-items-center gap-1">
            <i class="bi bi-plus-lg"></i> Buat Jadwal Seni
          </router-link>
        </div>
      </div>

      <!-- Search and Per Page Input -->
      <div class="d-flex justify-content-between align-items-center mb-3">
        <input
          v-model="searchQuery"
          @input="searchSchedule"
          type="text"
          class="form-control"
          placeholder="Cari Jadwal..."
        />
        <select v-model="perPage" @change="loadTournamentSchedules(1)" class="form-select w-auto">
          <option value="5">5 per halaman</option>
          <option value="10">10 per halaman</option>
          <option value="20">20 per halaman</option>
          <option value="50">50 per halaman</option>
        </select>
      </div>

      <!-- Bulk Actions Bar -->
      <div v-if="selectedScheduleIds.length > 0" class="alert alert-danger d-flex align-items-center justify-content-between py-2 px-3 mb-3 rounded-3 shadow-sm">
        <div class="d-flex align-items-center gap-2">
          <i class="bi bi-check2-square fs-5 text-danger"></i>
          <span class="fw-semibold text-danger">
            {{ selectedScheduleIds.length }} jadwal pertandingan dipilih
          </span>
        </div>
        <div class="d-flex align-items-center gap-2">
          <button type="button" class="btn btn-outline-secondary btn-sm" @click="selectedScheduleIds = []">
            Batal Pilih
          </button>
          <button type="button" class="btn btn-danger btn-sm d-flex align-items-center gap-1" @click="confirmBulkDeleteSchedule">
            <i class="bi bi-trash-fill"></i> Hapus Sekaligus ({{ selectedScheduleIds.length }})
          </button>
        </div>
      </div>

      <!-- Table to display tournament schedules -->
      <div class="table-responsive mt-3">
        <table class="table table-hover text-center align-middle mb-0 jadwal-daftar">
        <thead>
          <tr>
            <th style="width: 44px;">
              <input
                type="checkbox"
                class="form-check-input"
                :checked="isAllScheduleSelected"
                :indeterminate.prop="isScheduleIndeterminate"
                @change="toggleSelectAllSchedules"
                :disabled="!tournamentSchedules || tournamentSchedules.length === 0"
                title="Pilih semua jadwal di halaman ini"
              />
            </th>
            <th>No.</th>
            <th>No. Partai</th>
            <th>Turnamen</th>
            <th>Gelanggang</th>
            <th>Kategori</th>
            <th>Kelompok Usia</th>
            <th>Babak</th>
            <th>Tanggal</th>
            <th>Aksi</th>
          </tr>
        </thead>
        <tbody v-if="tournamentSchedules.length > 0">
          <tr v-for="(tournamentSchedule, index) in tournamentSchedules" :key="tournamentSchedule.id" :class="{ 'table-active': selectedScheduleIds.includes(tournamentSchedule.id) }">
            <td>
              <input
                type="checkbox"
                class="form-check-input"
                :value="tournamentSchedule.id"
                v-model="selectedScheduleIds"
              />
            </td>
            <td>{{ index + 1 + (currentPage - 1) * perPage }}</td>
            <td class="text-center">
              <span class="badge bg-primary">
                {{ tournamentSchedule.partai_label || '-' }}
              </span>
              <small class="d-block text-muted" v-if="tournamentSchedule.total_matches">
                {{ tournamentSchedule.total_matches }} Partai
              </small>
            </td>
            <td>{{ tournamentSchedule.tournament ? tournamentSchedule.tournament.name : 'Unknown Tournament' }}</td>
            <td>{{ tournamentSchedule.arena ? tournamentSchedule.arena.name : 'Unknown Arena' }}</td>
            <td>
              <span :class="tournamentSchedule.category_type === 'Seni' ? 'badge bg-success' : 'badge bg-info text-dark'">
                {{ tournamentSchedule.category_type || 'Tanding' }}
              </span>
            </td>
            <td>{{ getAgeCategoryName(tournamentSchedule) }}</td>
            <td>
              <span class="badge bg-secondary">
                {{ getRoundName(tournamentSchedule) }}
              </span>
            </td>
            <td>{{ tanggalRingkas(tournamentSchedule.scheduled_date) }}</td>
            <td class="action-column">
              <div class="d-flex gap-2 justify-content-end">
                <MenuAksi v-slot="{ tutup }">
                  <button type="button" class="aksi__item"
                          @click="tutup(); EditSchedule(tournamentSchedule.id)">
                    <i class="bi bi-pencil-square"></i> Ubah
                  </button>
                  <button type="button" class="aksi__item aksi__item--bahaya"
                          @click="tutup(); confirmDelete(tournamentSchedule.id)">
                    <i class="bi bi-trash"></i> Hapus
                  </button>
                </MenuAksi>
              </div>
            </td>
          </tr>
        </tbody>
        <tbody v-else>
          <tr>
            <td colspan="10" class="text-center">Tidak ada jadwal pertandingan ditemukan</td>
          </tr>
        </tbody>
      </table>
      </div>

      <!-- Pagination Controls -->
      <div class="d-flex justify-content-end mt-3">
        <AppPagination
          :current-page="currentPage"
          :total-pages="totalPages"
          :prev-page-url="prevPageUrl"
          :next-page-url="nextPageUrl"
          @change-page="changePage"
        />
      </div>
    </div>
  </div>
</template>

<script>
import { useToast } from 'vue-toastification';
import http from "@/services/http";
import MenuAksi from '@/components/ui/MenuAksi.vue';
import AppPagination from '@/components/ui/AppPagination.vue';
import * as bootstrap from 'bootstrap';

export default {
  name: "TournamentScheduleList",
  components: {
    MenuAksi,
    AppPagination,
  },
  setup() {
    const toast = useToast();
    return { toast };
  },
  data() {
    return {
      tournamentSchedules: [], // List of tournament match schedules
      loading: false, // Loading state
      progress: 0, // Progress bar percentage
      currentPage: 1, // Current page for pagination
      totalPages: 1, // Total pages for pagination
      perPage: 10, // Items per page
      nextPageUrl: null, // Next page URL
      prevPageUrl: null, // Previous page URL
      searchQuery: '', // Search query
      selectedScheduleId: null,
      selectedScheduleIds: [],
      deleteModalInstance: null,
      bulkDeleteModalInstance: null,
      bulkDeletingSchedule: false,
      reorderModalInstance: null,
      allTournaments: [],
      modalArenas: [],
      reorderForm: {
        tournament_id: '',
        tournament_arena_id: '',
        start_order: 1,
      },
      reordering: false,
    };
  },
  mounted() {
    this.loadTournamentSchedules();
    this.deleteModalInstance = new bootstrap.Modal(this.$refs.deleteModal);
    this.reorderModalInstance = new bootstrap.Modal(this.$refs.reorderModal);
    if (this.$refs.bulkDeleteScheduleModal) {
      this.bulkDeleteModalInstance = new bootstrap.Modal(this.$refs.bulkDeleteScheduleModal);
    }
    this.loadTournaments();
  },
  methods: {
    async loadTournaments() {
      try {
        const res = await http.get("/tournaments", { params: { fetch_all: true } });
        this.allTournaments = Array.isArray(res.data) ? res.data : res.data?.data || [];
      } catch (err) {
        console.debug('Failed to load tournaments', err);
      }
    },

    async loadModalArenas() {
      if (!this.reorderForm.tournament_id) {
        this.modalArenas = [];
        return;
      }
      try {
        const res = await http.get(`/tournament-arenas/${this.reorderForm.tournament_id}`);
        this.modalArenas = Array.isArray(res.data) ? res.data : res.data?.data || [];
      } catch (err) {
        this.modalArenas = [];
      }
    },

    openReorderModal() {
      if (this.allTournaments.length && !this.reorderForm.tournament_id) {
        this.reorderForm.tournament_id = this.allTournaments[0].id;
      }
      this.reorderForm.tournament_arena_id = '';
      this.loadModalArenas();
      this.reorderModalInstance.show();
    },

    async submitReorder() {
      if (!this.reorderForm.tournament_id) return;
      this.reordering = true;
      try {
        const res = await http.post("/match-schedules/reorder-tournament", this.reorderForm);
        this.toast?.success?.(res.data?.message || "Nomor partai berhasil diurutkan ulang");
        this.reorderModalInstance.hide();
        this.loadTournamentSchedules(this.currentPage);
      } catch (err) {
        this.toast?.error?.(err.response?.data?.message || err.response?.data?.error || "Gagal mengurutkan nomor partai");
      } finally {
        this.reordering = false;
      }
    },

    getAgeCategoryName(schedule) {
      if (schedule.age_category?.name) return schedule.age_category.name;
      const names = new Set();
      (schedule.details || []).forEach(d => {
        const tAge = d.tournament_match?.pool?.age_category?.name;
        const sAge = d.seni_match?.pool?.age_category?.name;
        if (tAge) names.add(tAge);
        if (sAge) names.add(sAge);
      });
      return names.size ? [...names].join(', ') : '-';
    },

    getRoundName(schedule) {
      if (schedule.round_label && schedule.round_label !== '-') return schedule.round_label;
      const rounds = new Set();
      (schedule.details || []).forEach(d => {
        const r = d.round_label || d.tournament_match?.round_label || d.seni_match?.round_label;
        if (r && r !== '-') rounds.add(r);
      });
      return rounds.size ? [...rounds].join(', ') : 'Final';
    },

    tanggalRingkas(nilai) {
      if (!nilai) return '-';
      const d = new Date(nilai);
      if (Number.isNaN(d.getTime())) return nilai;
      return d.toLocaleDateString('id-ID', { day: 'numeric', month: 'short', year: 'numeric' });
    },

    confirmDelete(id) {
      this.selectedScheduleId = id;
      this.deleteModalInstance.show();
    },

    async deleteSchedule() {
      if (!this.selectedScheduleId) return;

      try {
        await http.delete(`/match-schedules/${this.selectedScheduleId}`);

        this.toast?.success?.("Jadwal berhasil dihapus");
        this.deleteModalInstance.hide();
        this.loadTournamentSchedules(); // Refresh data
      } catch (error) {
        console.error("Gagal menghapus jadwal:", error);
        this.toast?.error?.("Gagal menghapus jadwal");
      }
    },
  
    async loadTournamentSchedules(page = 1) {
      this.loading = true;
      this.selectedScheduleIds = [];
      try {
        const response = await http.get("/match-schedules", {
          params: {
            page,
            perPage: this.perPage,
            search: this.searchQuery.trim(),
          },
        });
        const {
          current_page,
          last_page,
          data,
          next_page_url,
          prev_page_url,
        } = response.data;

        this.tournamentSchedules = data || []; // Assign team members
        this.currentPage = current_page || 1; // Current page
        this.totalPages = last_page || 1; // Total pages
        this.nextPageUrl = next_page_url; // Next page URL
        this.prevPageUrl = prev_page_url; // Previous page URL
        this.loading = false;
      } catch (error) {
        console.error("Error loading data:", error);
        this.loading = false;
      }
    },

    changePage(page) {
      if (page >= 1 && page <= this.totalPages) {
        this.loadTournamentSchedules(page);
      }
    },


    searchClasses() {
      this.currentPage = 1; // Reset to page 1 for new search
      this.loadTournamentArenas();
    },

    AddSchedule() {
      this.$router.push('/admin/tournament-schedule/tanding/create');
    },

    AddScheduleSeni() {
      this.$router.push('/admin/tournament-schedule/seni/create');
    },

    EditSchedule(id) {
      const schedule = this.tournamentSchedules.find(item => item.id === id);

      if (!schedule) {
        this.toast.error("Schedule not found");
        return;
      }

      const isSeni = !!schedule.details?.[0]?.seni_match;

      const route = isSeni
        ? `/admin/tournament-schedule/seni/edit/${id}`
        : `/admin/tournament-schedule/tanding/edit/${id}`;

      this.$router.push(route);
    },


    deleteMenu(id) {
      // Implement logic to delete the menu (e.g., API call)


      // Parameter dipertahankan untuk saat fungsi ini diimplementasikan.


      void id;
    },

    toggleSelectAllSchedules() {
      if (this.isAllScheduleSelected) {
        const currentIds = (this.tournamentSchedules || []).map((s) => s.id);
        this.selectedScheduleIds = this.selectedScheduleIds.filter((id) => !currentIds.includes(id));
      } else {
        const newIds = new Set(this.selectedScheduleIds);
        (this.tournamentSchedules || []).forEach((s) => newIds.add(s.id));
        this.selectedScheduleIds = Array.from(newIds);
      }
    },

    confirmBulkDeleteSchedule() {
      if (this.selectedScheduleIds.length === 0) return;
      if (!this.bulkDeleteModalInstance && this.$refs.bulkDeleteScheduleModal) {
        this.bulkDeleteModalInstance = new bootstrap.Modal(this.$refs.bulkDeleteScheduleModal);
      }
      this.bulkDeleteModalInstance?.show();
    },

    async deleteBulkSchedule() {
      if (this.selectedScheduleIds.length === 0) return;
      this.bulkDeletingSchedule = true;
      try {
        const res = await http.post("/match-schedules/bulk-delete", {
          ids: this.selectedScheduleIds,
        });
        this.toast?.success?.(res.data?.message || "Jadwal pertandingan berhasil dihapus");
        this.selectedScheduleIds = [];
        this.bulkDeleteModalInstance?.hide();
        this.loadTournamentSchedules(this.currentPage);
      } catch (err) {
        this.bulkDeleteModalInstance?.hide();
        const msg = err.response?.data?.message || err.response?.data?.error || "Gagal menghapus jadwal pertandingan";
        this.toast?.error?.(msg);
      } finally {
        this.bulkDeletingSchedule = false;
      }
    },
  },
  computed: {
    isAllScheduleSelected() {
      if (!this.tournamentSchedules || this.tournamentSchedules.length === 0) return false;
      return this.tournamentSchedules.every((s) => this.selectedScheduleIds.includes(s.id));
    },
    isScheduleIndeterminate() {
      const selected = (this.tournamentSchedules || []).filter((s) => this.selectedScheduleIds.includes(s.id));
      return selected.length > 0 && selected.length < (this.tournamentSchedules || []).length;
    },
    prevPageExists() {
      return this.currentPage > 1;
    },
    nextPageExists() {
      return this.currentPage < this.totalPages;
    },
  },
};
</script>

<style scoped>
.jadwal-daftar { border-collapse: separate; border-spacing: 0; }
.jadwal-daftar > :not(caption) > * > * { border-left: 0 !important; border-right: 0 !important; border-color: var(--border-subtle, #e5e7eb); background: transparent; box-shadow: none; }
.jadwal-daftar thead th { background: var(--bg-sunken, #f3f4f6); font-size: .75rem; letter-spacing: .04em; color: var(--text-secondary, #4b5563); }
.jadwal-daftar tbody tr:hover > * { background: var(--bg-sunken, #f8fafc); }

.table th,
.table td {
  padding: 10px;
}






.form-control {
  width: 250px;
}

.progress-bar {
  position: absolute;
  top: 0;
  left: 0;
  height: 5px;
  background: var(--grad-flame);
  animation: loader-animation 1.5s infinite;
}

/* Animasi garis loader */
@keyframes loader-animation {
  0% {
    width: 0;
    background: var(--grad-flame); /* Warna awal */
  }
  50% {
    width: 50%;
    background: var(--grad-flame); /* Warna saat animasi */
  }
  100% {
    width: 100%;
    background: var(--grad-flame);
  }
}
</style>
